export default __webpack_public_path__ + "static/media/leaveFeedback.59118f60.svg";